import {
  ApolloCache,
  ApolloError,
  DefaultContext,
  FetchResult,
  MutationFunctionOptions,
} from '@apollo/client';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { tabRoutes } from '../../constants/hinge-connect-constants.constant';
import { getApolloErrorMessages } from '../../utils/get-apollo-error-messages';
import { rulesRoutes } from '../constants/rules.constant';
import {
  Exact,
  GetRuleDocument,
  ListRulesDocument,
  UpdateRuleInput,
  UpdateRuleMutation,
  useUpdateRuleMutation,
} from '../types';

interface UseUpdateRuleHook {
  updateRule: (
    options?:
      | MutationFunctionOptions<
          UpdateRuleMutation,
          Exact<{
            id: string;
            updateRuleInput: UpdateRuleInput;
          }>,
          DefaultContext,
          ApolloCache<unknown>
        >
      | undefined,
  ) => Promise<
    FetchResult<
      UpdateRuleMutation,
      Record<string, unknown>,
      Record<string, unknown>
    >
  >;
  data: unknown;
  loading: boolean;
  error: ApolloError | undefined;
  errorMessages: string;
}

export const useUpdateRule = (): UseUpdateRuleHook => {
  const navigate = useNavigate();
  const [errorMessages, setErrorMessages] = useState('');

  const [updateRule, { data, loading, error }] = useUpdateRuleMutation({
    refetchQueries: [GetRuleDocument, ListRulesDocument],
    onError: (error: ApolloError) => {
      setErrorMessages(getApolloErrorMessages(error));
    },
    onCompleted: ({ updateRule }) => {
      navigate(
        `/${tabRoutes.baseRoute}/${tabRoutes.rules}/${updateRule.id}/${rulesRoutes.view}`,
      );
    },
  });

  return { updateRule, data, loading, error, errorMessages };
};
